<div class="tw-border-gray-300">
	<ul class="list-group tree" *ngIf="filterModel.show">
		<ng-template #recursiveList let-nodes>
			<li *ngFor="let node of nodes">
				<div class="row" [ngClass]="{ 'active-node': selectedNodeId == node.model?.id }">
					<div class="col p-1 m-1">
						<div class="d-flex align-items-center tw-gap-2">
							<i
								*ngIf="node.children?.length > 0"
								class="tw-font-size-20 tw-ml-[-3px] tw-flex-shrink-0"
								(click)="node.expanded = !node.expanded"
								[class]="node.expanded ? 'fa fa-minus' : 'fa fa-plus'"
								class="pr-2 link"></i>
							<div [attr.class]="'node'" role="button" (click)="onCheckboxChange(node)" class="link tw-flex-1 tw-whitespace-nowrap">
								<span [class]="node.checked ? 'checked' : 'no-checked'" class="tw-block">
									<div class="">{{ node.model?.name }}</div>
								</span>
							</div>
							<i *ngIf="selectedNodeId == node.model?.id && isLoading"
								class="fa fa-times tw-flex-shrink-0 tw-ml-auto tw-cursor-pointer tw-text-gray-500 hover:tw-text-red-600 tw-transition-colors"
								(click)="clearSelection($event)"
								title="Cancel loading">
							</i>
							<!-- <i class="tw-flex-shrink-0 tw-ml-auto tw-mr-10" [style.color]="node.checked ? '#243670' : 'grey'" [class]="node.checked ? 'fa fa-check-circle' : 'fa fa-circle'"></i> -->
						</div>
					</div>
				</div>
				<ul *ngIf="node.children?.length > 0 && node.expanded">
					<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: node.children }"></ng-container>
				</ul>
			</li>
		</ng-template>
		<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: filteredNodes }"></ng-container>
	</ul>
</div>
